import { motion } from 'framer-motion'
import styled, { createGlobalStyle, css } from 'styled-components'
import { ArrowRightIcon } from '@velasca/icons/arrow-right'
import { BrandLogo } from '@velasca/ui/brand-logo'
import { UnstyledList } from '@velasca/ui/unstyled-list'

export const ScrollLockGlobalStyles = createGlobalStyle`
  body.scroll-locked {
    padding-right: var(--scrollbar-width, 0);
  }
`

export const Header = styled.div<{
  isOpen: boolean
  top: boolean
  animationDone: boolean
  $height: number
}>`
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;

  ${({ isOpen, animationDone, $height }) =>
    (isOpen || !animationDone) &&
    css`
      height: ${$height}px;
    `};
`

export const Navbar = styled.nav<{
  isOpen: boolean
  top: boolean
  sticky: boolean | string
  searchActivated: boolean
}>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: ${({ isOpen }) => (isOpen ? 'auto' : 'hidden')};
  background: ${({ theme, isOpen, top, sticky, searchActivated }) =>
    (isOpen || !top || sticky || searchActivated) &&
    theme.colors.boxBackground};
  transition: background 0.2s cubic-bezier(0, 0, 0, 1) 0s;
`

export const LogoContainer = styled.h1`
  font-size: 1.6rem;
  line-height: 1;
`

export const MenuLists = styled(motion.div)<{ upperGap: number }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: calc(7rem - ${({ upperGap }) => upperGap}px);
  padding: 0 1.25rem;
  background: #f5f5f5;
  height: 100%;
  overflow-y: auto;
`

const Chunk = styled.div`
  margin: 0.5rem;
  flex: 33.33%;
`

export const StartChunk = styled(Chunk)`
  display: flex;
  justify-content: flex-start;
`

export const CenterChunk = styled(Chunk)`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const EndChunk = styled(Chunk)`
  margin-right: 12px;
  justify-content: flex-end;
`

export const LinkNoDecoration = styled.a`
  &:hover,
  &:link,
  &:visited,
  &:active {
    text-decoration: none;
  }
`

export const Link = styled(LinkNoDecoration)`
  display: flex;
  align-items: center;
`

export const RightSideContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
`

export const StyledBrandLogoExtended = styled(BrandLogo.Extended)<{
  variant: 'primary' | 'white'
}>`
  width: 10rem;
  height: auto;
  transition: all 0.2s cubic-bezier(0, 0, 0, 1) 0s;
`

export const Bar = styled.div<{
  isOpen: boolean
  top: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0.5rem 0;

  background: ${({ theme, isOpen, top }) =>
    isOpen || !top ? theme.colors.boxBackground : 'trasparent'};
  transition: all 0.2s cubic-bezier(0, 0, 0, 1) 0s;
`

export const LowerMenu = styled(UnstyledList)``

export const LowerMenuListItem = styled.li`
  padding: 1rem 0;
`

export const CountryLowerMenuListItem = styled(LowerMenuListItem)`
  padding: 1.5rem 0;
  border-top: 1px solid ${({ theme }) => theme.colors.secondary};
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const LowerMenuTitle = styled.span`
  .text {
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 1.25;
    letter-spacing: 0;
    color: ${({ theme }) => theme.colors.text.primary};
  }
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const ArrowTop = styled(ArrowRightIcon)`
  width: 1rem;
  height: 1rem;
  transform: rotate(-90deg);
`

export const LowerMenuIconWrapper = styled.span`
  display: flex;
  width: 1.9rem;
  height: 1.8rem;
  margin-top: -1px;
`

export const LowerMenuCurrencySwitch = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
`
